import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpResponse, HttpEventType, HttpProgressEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { scan } from 'rxjs/operators';

//triangolare per ricaricare la pagina
export const navigateToSamePage = (injector: Injector, pageUrlAsString) => injector.get(Router).navigateByUrl('/', { skipLocationChange: true })
                                                                           .then(() => injector.get(Router).navigate([pageUrlAsString]));

export const openLinkInNewTab = linkUrl => window.open(linkUrl, "_blank");

export const isClassPresentInDomEventTarget = (event, className: string) => event.target.className.split(' ').includes(className)

export const encodeValueForInput = value => new Date().toISOString() + JSON.stringify(value)
  
export const decodeUpdatableInput = (value: string) => value ? JSON.parse(value.slice(24)) : value

export const log = (module, func, key, value, color, primary?: boolean) => {
    let fontColor, background;
    if(primary){
      fontColor = 'white';
      background = color;
    }else{
      fontColor = 'black';
      background = 'transparent';
    }
    console.log(`%c ${module}.${func} - ${key}: ${value}`, `background: ${background}; color: ${fontColor}; border:2px solid ${color}; padding: 2px;`);
}

export const debug = (module, func, key, value, color) => {
  let fontColor, background;
  fontColor = color;
  background = 'transparent';
  
  console.log(`%c ${module}.${func} - ${key}: ${value}`, `background: ${background}; color: ${fontColor}; border:none; padding: 2px;`);
}

export interface FileTransfer {
  state: 'PENDING' | 'IN_PROGRESS' | 'DONE'
  progress: number
  content: Blob | string | null
}

/**
 * https://nils-mehlhorn.de/posts/angular-file-download-progress
 */
export function fileTransfer(): (source: Observable<HttpEvent<Blob>>) => Observable<FileTransfer> {
  return (source: Observable<HttpEvent<Blob>>) =>
    source.pipe(
      scan((previous: FileTransfer, event: HttpEvent<Blob>): FileTransfer => {
          if (isHttpProgressEvent(event)) {
            return {
              progress: event.total
                ? Math.round((100 * event.loaded) / event.total)
                : previous.progress,
              state: 'IN_PROGRESS',
              content: null
            }
          }
          if (isHttpResponse(event)) {
            return {
              progress: 100,
              state: 'DONE',
              content: event.body
            }
          }
          return previous
        },
        {state: 'PENDING', progress: 0, content: null}
      )
    )
}

function isHttpResponse<T>(event: HttpEvent<T>): event is HttpResponse<T> {
  return event.type === HttpEventType.Response
}

function isHttpProgressEvent(event: HttpEvent<unknown>): event is HttpProgressEvent {
  return event.type === HttpEventType.DownloadProgress 
      || event.type === HttpEventType.UploadProgress
}